export default __webpack_public_path__ + "static/media/excelFileIcon.829798f9.svg";